import React from 'react'
import Reimbursements from 'src/app/Reimbursements/Reimbursements'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { orgSettingsReimbursementsRouteProps } from 'src/navigation/routeProps'

const OrgSettingsReimbursementsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsReimbursements,
  routeProps: orgSettingsReimbursementsRouteProps,
  component: <Reimbursements />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default OrgSettingsReimbursementsAppRoute